import { IconButton, Stack, Tooltip } from "@mui/material";
import Iconify from "../../minimals/components/iconify";

type Prop = {
  orderNumber: string | undefined;
  isLink?: boolean;
};
const momentumUrl = import.meta.env.VITE_MOMENTUM_URL;
////isLink is to use an achor version of this so as to display the link when hovering over the link
export default function OpenInHomePageButton({ orderNumber, isLink = false }: Prop) {
  const url = `${momentumUrl}new-home/${orderNumber}`;

  if (!isLink) {
    return (
      <Tooltip title="View in Momentum">
        <IconButton onClick={() => window.open(url, "_blank")?.focus()} size="small">
          <Iconify icon={"eva:external-link-fill"} />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        textDecoration: "none",
        color: "inherit",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 32,
        height: 32,
        borderRadius: "50%",
        transition: "background 0.2s"
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0, 0, 0, 0.04)")}
      onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
    >
      <Iconify icon="eva:external-link-fill" />
    </a>
  );
}
